import { Component, Mixins } from "vue-property-decorator";
import { mapState } from "vuex";
import { IState } from "@/store";
import { DataModules } from "@/store/modules/data";
import { IPricelist } from "@/models/products";
import BrandsStore from "@/mixins/brandsStore";

@Component({
  computed: {
    ...mapState({
      priceListsScope(state: IState, getters) {
        return getters[`data/${DataModules.PRICELISTS}/priceListsScope`](
          this.brandId
        );
      },
      priceLists(state: IState, getters) {
        return getters[`data/listArray`]({
          storeModule: DataModules.PRICELISTS,
          scope: this.priceListsScope
        });
      }
    })
  }
})
export default class PriceListsStore extends Mixins(BrandsStore) {
  public priceListsScope!: string;
  public priceLists!: IPricelist[];

  public getPriceLists(ignoreStored = false) {
    return this.$store.dispatch(`data/${DataModules.PRICELISTS}/list`, {
      scope: this.priceListsScope,
      vm: this,
      params: { limit: 0, with: "parents" },
      ignoreStored
    });
  }

  public beforeDestroy() {
    this.$store.dispatch("data/binList", {
      storeModule: DataModules.PRICELISTS,
      scope: this.priceListsScope,
      vm: this
    });
  }
}
